import {STATE_PROP_NAME} from './my-entity-star-constants'

export const getRoot = state => state[STATE_PROP_NAME]
export const getByKey = (key, state) => getRoot(state)[key]
